import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTypedDispatch, useTypedSelector } from '@/store';
import { openTag, setIsDrawerOpened } from '@/store/core';
import { Button } from 'antd';

import LoadingMask from '@/components/LoadingMask';
import { fetchTags } from '@/store/tags/thunkActions';

import type { OpenedTagState } from '@/types/store/core';

import ThreeDotsIcon from '@/assets/icons/three-dots.svg?react';

const Tags = () => {
  const [t] = useTranslation();
  const dispatch = useTypedDispatch();

  const tags = useTypedSelector(state => state.tags);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onOpenTag = (payload: OpenedTagState) => {
    dispatch(setIsDrawerOpened(false));
    dispatch(openTag(payload));
  };
  const onFetchTags = async () => {
    setIsLoading(true);
    await dispatch(fetchTags());
    setIsLoading(false);
  };

  useEffect(() => {
    onFetchTags();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="tags">
        <LoadingMask isLoading={isLoading} zIndex={20} width={40} height={40} />

        <div className="tags__body">
          {tags.map(item => (
            <div className="tags__item" key={item._id}>
              <div className="tags__item-color" style={{ backgroundColor: item.color }} />
              <span className="tags__item-name" title={item.name}>
                {item.name}
              </span>
              <ThreeDotsIcon
                className="tags__item-dots"
                onClick={() => onOpenTag({ type: 'edit', _id: item._id })}
              />
            </div>
          ))}
        </div>

        <div className="tags__actions">
          <Button type="primary" className="tags__add-button" onClick={() => onOpenTag({ type: 'new' })}>
            + {t('addProject')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Tags;
